<div class="share__link-container w-[450px] h-[310px] max-h-[95vh] p-5">
  <div class="flex justify-between">
    <h5 class="font-bold text-xl text-[#010B18]">Remove Password</h5>
    <div class="web__close-icon">
      <button type="button" class="close" data-dismiss="modal" (click)="closeDialog()">
        <span class="material-icons icons-close-mobile text-[#25508E]">close</span>
      </button>
    </div>
  </div>
  <div class="">
    <p class="mt-5 text-xs text-[#707070] font-normal">
      <span class="font-bold">To analyze this file</span>, <span class="text-[#25508E] font-bold">Kinnect AI </span>
      <span class="font-bold">needs the password removed</span>. You can still save it as-is, but Kinnect won’t generate a summary, and anyone you
      share it with will need the password to open it.
    </p>
    <form [formGroup]="askPasswordForm">
      <div class="share__link-footer-content">
        <mat-form-field appearance="fill" class="form-design-ui" style="width: 100% !important">
          <input [type]="visibility ? 'text' : 'password'" class="custom-input" placeholder="Enter Password" matInput formControlName="password" />
          @if (askPasswordForm.controls['password'].value == '') {
          <mat-error> Password is required. </mat-error>
          }
          <mat-error *ngIf="askPasswordForm.get('password')?.hasError('incorrect')"> Incorrect password, please try again. </mat-error>
          <mat-icon class="text-[#25508E]" (click)="visibility = !visibility">{{ visibility ? 'visibility_off' : 'visibility' }} </mat-icon>
        </mat-form-field>
        <div class="share__link-btn">
          <button
            class="h-[48px] w-full mt-2 rounded-lg text-base font-semibold text-white"
            (click)="removePassword()"
            [style.background-color]="askPasswordForm.valid ? '#25508E' : '#010b181f'"
          >
            Remove Password
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
